/* eslint-disable @repo/internal/react/require-jsdoc */
import { type Context, createContext } from 'react';

import type { FlagOverrides } from './types';

type FeatureFlagOverridesContextProps = {
	flagOverrides: FlagOverrides;
};

export const FeatureFlagOverridesContext: Context<FeatureFlagOverridesContextProps> =
	createContext<FeatureFlagOverridesContextProps>({
		flagOverrides: {},
	});
